module.exports = __webpack_public_path__ + "static/media/hamza-mahal-round-lossy.1a1ecba8.png";